import { render, staticRenderFns } from "./CistiTable.vue?vue&type=template&id=610298c4&"
import script from "./CistiTable.vue?vue&type=script&lang=js&"
export * from "./CistiTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports